import { useEffect } from 'react';

import { useAuth } from '../hooks/use-auth';
import { useProfileQuery } from '../hooks/use-profile-query';

import { setLanguage } from './init';

/**
 * Sync the active i18next language with the user-profile React Query
 * cache (mirrors mobile/src/i18n/use-i18n-sync.ts). Mount inside
 * `Shell` so post-auth profile changes propagate.
 *
 * Profile-query gating: `Shell` itself only mounts this hook for any
 * route, including the unauthenticated landing. TanStack runs a query
 * if ANY observer enables it, so even though `Shell`'s own
 * `useProfileQuery({ enabled: !!user })` is gated, an ungated observer
 * here would defeat that gate and fire `/users/profile` 401s on the
 * pre-auth landing. Mirror the same gate.
 */
export function useI18nSync(): void {
  const { user } = useAuth();
  const profile = useProfileQuery({ enabled: !!user });
  const primaryLanguage = profile.data?.primaryLanguage;

  useEffect(() => {
    if (primaryLanguage) {
      setLanguage(primaryLanguage);
    }
  }, [primaryLanguage]);
}
